import React, { useState, useEffect } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

const MultiSelectAll = (props) => 
{
    /*const customStyles = {
        option: (provided, state) => ({
          ...provided,
          //borderBottom: '1px dotted pink',
          color: state.isSelected ? '#75287C' : '#495057',
          padding: 20,
        }),
       
        singleValue: (provided, state) => {
          const opacity = state.isDisabled ? 0.5 : 1;
          const transition = 'opacity 300ms';
      
          return { ...provided, opacity, transition };
        }
      }*/

    const [selectedOptions, setSelectedOptions] = useState([]);
    const { checkboxItemsList } = props;
    
    function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
      if (value && value.some((o) => o.value === "*")) {
        return `${placeholderButtonLabel}: All`;
      } else {
        return `${placeholderButtonLabel}: ${value?.length}`;
      }
    }
  
    function onChange(value, event) 
    {
      if (event.action === "select-option" && event.option.value === "*")
      {
        props.toggleAll();
      } 
      else if ( event.action === "deselect-option" && event.option.value === "*") 
      {
        props.toggleAll();
      } 
      else if (event.action === "deselect-option") 
      {
        props.toggleSelection(value.filter((o) => o.value !== "*"));
      } 
      else if (value.length === checkboxItemsList?.length ) 
      {
        props.toggleAll();
      } 
      else 
      {
        props.toggleSelection(value);
      }
    }
  
    return (
      <ReactMultiSelectCheckboxes
        options={[{label: "All", value: "*" }, ...checkboxItemsList]}
        placeholderButtonLabel={props.placeholderButtonLabel}
        getDropdownButtonLabel={getDropdownButtonLabel}
        value={props.selectedOptions}
        onChange={onChange}
        //styles={customStyles}
      />
    );
  };
  
  export default MultiSelectAll;